import * as types from '../constants/almataConstants';

const initialState = {
  partners: [],
  scanTypes: [],
  oemPartners: [],
  oemUsers: [],
  loading: false,
  formLoading: false,
  scanTypesLoading: false,
  oemLoading: false,
  oemUsersLoading: false,
  error: null,
  success: false,
  passwordResetStatus: null,
  pagination: {
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  oemPagination: {
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  oemUsersPagination: {
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
};

const almataReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Almata Partners
    case types.GET_ALMATA_PARTNERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_ALMATA_PARTNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        partners: action.payload.response || [],
        pagination: {
          totalPages: action.payload.pagination?.totalPages || 0,
          totalItems: action.payload.pagination?.totalItems || 0,
          itemsPerPage: action.payload.pagination?.itemsPerPage || 10,
          currentPage: action.payload.pagination?.currentPage || 1,
        },
        error: null,
      };
    case types.GET_ALMATA_PARTNERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        partners: [],
      };

    // Add Almata Partner
    case types.ADD_ALMATA_PARTNER_REQUEST:
      return {
        ...state,
        formLoading: true,
        error: null,
        success: false,
      };
    case types.ADD_ALMATA_PARTNER_SUCCESS:
      return {
        ...state,
        formLoading: false,
        success: true,
        partners: action.payload.response || state.partners,
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.ADD_ALMATA_PARTNER_FAILURE:
      return {
        ...state,
        formLoading: false,
        error: action.payload,
        success: false,
      };

    // Edit Almata Partner
    case types.EDIT_ALMATA_PARTNER_REQUEST:
      return {
        ...state,
        formLoading: true,
        error: null,
        success: false,
      };
    case types.EDIT_ALMATA_PARTNER_SUCCESS:
      return {
        ...state,
        formLoading: false,
        success: true,
        partners: action.payload.response || state.partners,
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.EDIT_ALMATA_PARTNER_FAILURE:
      return {
        ...state,
        formLoading: false,
        error: action.payload,
        success: false,
      };

    // Delete Almata Partner
    case types.DELETE_ALMATA_PARTNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_ALMATA_PARTNER_SUCCESS:
      return {
        ...state,
        loading: false,
        partners: action.payload.response || state.partners,
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.DELETE_ALMATA_PARTNER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Change Almata Status
    case types.CHANGE_ALMATA_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.CHANGE_ALMATA_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        partners: action.payload.response || state.partners,
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.CHANGE_ALMATA_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get Scan Types
    case types.GET_ALMATA_SCAN_TYPES_REQUEST:
      return {
        ...state,
        scanTypesLoading: true,
        error: null,
      };
    case types.GET_ALMATA_SCAN_TYPES_SUCCESS:
      return {
        ...state,
        scanTypesLoading: false,
        scanTypes: action.payload || [],
        error: null,
      };
    case types.GET_ALMATA_SCAN_TYPES_FAILURE:
      return {
        ...state,
        scanTypesLoading: false,
        error: action.payload,
      };

    // Get OEM Partners
    case types.GET_OEM_PARTNERS_REQUEST:
      return {
        ...state,
        oemLoading: true,
        error: null,
      };
    case types.GET_OEM_PARTNERS_SUCCESS:
      return {
        ...state,
        oemLoading: false,
        oemPartners: action.payload.response || [],
        oemPagination: {
          totalPages: action.payload.pagination?.totalPages || 0,
          totalItems: action.payload.pagination?.totalItems || 0,
          itemsPerPage: action.payload.pagination?.itemsPerPage || 10,
          currentPage: action.payload.pagination?.currentPage || 1,
        },
        error: null,
      };
    case types.GET_OEM_PARTNERS_FAILURE:
      return {
        ...state,
        oemLoading: false,
        error: action.payload,
        oemPartners: [],
      };

    // Get OEM Partner Users
    case types.GET_OEM_PARTNER_USERS_REQUEST:
      return {
        ...state,
        oemUsersLoading: true,
        error: null,
      };
    case types.GET_OEM_PARTNER_USERS_SUCCESS:
      return {
        ...state,
        oemUsersLoading: false,
        oemUsers: action.payload.response || [],
        oemUsersPagination: {
          totalPages: action.payload.pagination?.totalPages || 0,
          totalItems: action.payload.pagination?.totalItems || 0,
          itemsPerPage: action.payload.pagination?.itemsPerPage || 10,
          currentPage: action.payload.pagination?.currentPage || 1,
        },
        error: null,
      };
    case types.GET_OEM_PARTNER_USERS_FAILURE:
      return {
        ...state,
        oemUsersLoading: false,
        error: action.payload,
        oemUsers: [],
      };

    // Reset Almata Password
    case types.RESET_ALMATA_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.RESET_ALMATA_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        passwordResetStatus: action.payload?.status || 200,
        error: null,
      };
    case types.RESET_ALMATA_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Clear actions
    case types.CLEAR_ALMATA_SUCCESS:
      return {
        ...state,
        success: false,
        passwordResetStatus: null,
      };
    case types.CLEAR_ALMATA_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.RESEND_ALMATA_VERIFICATION_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.RESEND_ALMATA_VERIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
      };
    case types.RESEND_ALMATA_VERIFICATION_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default almataReducer;